import { render, staticRenderFns } from "./InstallationsStatusChangesTable.vue?vue&type=template&id=80311556&"
import script from "./InstallationsStatusChangesTable.vue?vue&type=script&lang=ts&"
export * from "./InstallationsStatusChangesTable.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationsStatusChangesTable.vue?vue&type=style&index=0&id=80311556&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBadge,VCard,VCardText,VChip,VDataTable})
